import get from 'lodash/get';
import { getResellerData, getResellerId } from './reseller';

export default async () => {
  const resellerId = getResellerId();
  const resellerData = await getResellerData(resellerId);

  return get(resellerData, ['gdprEnable'], false);
};
